<template>
  <div class="inquiry-list">
    <my-title />

    <div class="container">
      <!-- tab -->
      <ul
        v-if="viewTabs.length"
        ref="copyTab"
        class="copy-tab clearfix"
      >
        <li
          v-for="item in viewTabs"
          :key="item.id"
          class="fl"
        >
          {{ item.name }}
        </li>
      </ul>
      <div
        v-if="viewTabs.length"
        class="tab-wrap clearfix"
      >
        <a-tabs
          :active-key="viewid"
          class="fl"
          @change="handleTabs"
        >
          <a-tab-pane
            v-for="item in viewShowList"
            :key="item.id"
            :tab="item.name"
          />
        </a-tabs>
        <a-dropdown
          v-if="viewHideList.length"
          class="fr"
        >
          <a
            class="ant-dropdown-link"
            @click="e => e.preventDefault()"
          >
            <span class="fs-gray999 fz-18">{{ $t('message["377"]') }}</span>
            <i
              class="iconfont iconicon-test15 fz-13 m-l-4"
              :class="{'fs-blue': viewHideList.find(item => item.id === viewid)}"
            />
          </a>
          <a-menu slot="overlay">
            <a-menu-item
              v-for="item in viewHideList"
              :key="item.id"
              :class="{'ant-dropdown-menu-item-active': item.id === viewid}"
              @click="handleClickViewHideMenu(item)"
            >
              <a href="javascript:;">{{ item.name }}</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>

      <!-- 设置栏 -->
      <div class="setting-bar clearfix">
        <div
          v-if="searchConfig"
          class="search-form left fl"
        >
          <a-input-group
            compact
            class="fl"
          >
            <a-select
              v-if="searchConfig.key"
              :value="searchConfig.key"
              @change="handleChangeSearchConfig"
            >
              <a-select-option
                v-for="item in searchConfig.options"
                :key="item.fieldkey"
                :value="item.fieldkey"
              >
                {{ item.fieldname }}
              </a-select-option>
              <i
                slot="suffixIcon"
                class="iconfont iconicon-test19"
              />
            </a-select>
            <a-input
              v-model="searchConfig.value"
              :placeholder="searchConfig.placeholder"
              @change="handleInput"
              @keyup.enter="onSearch"
            />
          </a-input-group>
          <a-button
            type="primary"
            @click="onSearch"
          >
            {{ $t('message["91"]') }}
          </a-button>
          <a-button @click="onReset">
            {{ $t('message["1625"]') }}
          </a-button>
        </div>

        <div class="right fr">
          <div
            v-if="filterStr"
            class="filter-num"
          >
            {{ selectedTxt[0] }}{{ pagination.total }}{{ selectedTxt[1] }}{{ pagination.allCount }}{{ $t('message["1713"]') }}{{ selectedTxt[2] }}
            <i
              class="clear-filter-btn"
              @click="clearFilter"
            >
              {{ $t('message["736"]') }}
            </i>
          </div>
          <!-- <field-config
            :from="from"
            :type="type"
            :params-type="_type"
          /> -->
          <a-button
            v-if="showFilterIcon"
            class="filter-icon"
            :class="{'fs-blue': filterStr }"
            @click="openFilter"
          >
            <i class="iconfont iconicon-test20" />
            {{ $t('message["960"]') }}
          </a-button>
          <a-button
            v-if="baseinfo.vip"
            class="export-icon"
            @click="openExport"
          >
            <i class="iconfont iconicon-test22" />
            {{ $t('message["185"]') }}
          </a-button>
        </div>
      </div>
      <!-- 列表 -->
      <my-table
        ref="myTable"
        :from="from"
        :type="type"
        :params-type="_type"
        :fieldkey="fieldkey"
        :fieldvalue="fieldvalue"
        @clearSearchConfig="clearSearchConfig"
      />
      <!-- 筛选配置弹窗 -->
      <filter-config-modal
        :visible.sync="showFilterConfigModal"
        :from="from"
        :type="type"
        :params-type="_type"
        class="export-config-modal"
      />
      <!-- 筛选弹窗 -->
      <filter-modal
        ref="filterModal"
        :visible.sync="showFilterModal"
        :from="from"
        :type="type"
        :params-type="_type"
        class="filter-modal"
      />
      <!-- 导出配置弹窗 -->
      <export-config-modal
        :visible.sync="showExportConfigModal"
        :from="from"
        :type="type"
        :params-type="_type"
        :fieldkey="fieldkey"
        :fieldvalue="fieldvalue"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import eventBus from '@/lib/eventBus'
import MyTitle from '@/components/pc/Title'
import MyTable from './Table'
import FilterConfigModal from './FilterConfig'
import FilterModal from './Filter'
import ExportConfigModal from './ExportConfig'

export default {
  components: {
    MyTitle,
    MyTable,
    FilterConfigModal,
    FilterModal,
    ExportConfigModal
  },
  data () {
    return {
      // scope: 数据范围 我的：my 全部：all
      // type: 类型 dev|input|audit|follow|share, 状态 1 跟进中 2 待分配 3 待指派 4 共享
      showFilterConfigModal: false,
      showFilterModal: false,
      showExportConfigModal: false,
      showFilterIcon: false,
      viewid: '',
      issystem: ''
    }
  },

  computed: {
    ...mapState([
      'baseinfo'
    ]),
    ...mapState('inquery/listData', [
      'searchConfig',
      'pagination',
      'viewTabs'
    ]),
    ...mapState('inquery/filterData', ['filterStr']),
    from () {
      return this.$route.query.from || 'all'
    },
    type () {
      return this.$route.query.type
    },
    _type () {
      let data = ''
      if (this.from === 'all') {
        switch (this.type) {
          // 管理员/负责人
          case 'inquiry-manager-all':
            data = 0
            break
          case 'inquiry-manager-followup':
            data = 1
            break
          case 'inquiry-manager-need-allocate':
            data = 2
            break
          case 'inquiry-manager-need-assign':
            data = 3
            break
          case 'inquiry-manager-share':
            data = 4
            break
          case 'inquiry-manager-archive':
            data = 5
            break
          // 主管、组长
          case 'inquiry-dev':
            data = 'dev'
            break
          case 'inquiry-add':
            data = 'input'
            break
          case 'inquiry-audit':
            data = 'audit'
            break
          case 'inquiry-followup':
            data = 'follow'
            break
          case 'inquiry-share':
            data = 'share'
            break
          case 'inquiry-archive':
            data = 'archive'
            break
        }
      }
      if (this.from === 'my') {
        switch (this.type) {
          case 'inquiry-dev':
            data = 'dev'
            break
          case 'inquiry-add':
            data = 'input'
            break
          case 'inquiry-audit':
            data = 'audit'
            break
          case 'inquiry-followup':
            data = 'follow'
            break
          case 'inquiry-share':
            data = 'share'
            break
        }
      }

      return data
    },
    query () {
      return this.$route.query || {}
    },
    fieldkey () {
      let fieldkey = this.query.fieldkey
      return fieldkey
    },
    fieldvalue () {
      let fieldvalue = this.query.fieldvalue || ''
      if (fieldvalue) {
        fieldvalue = decodeURIComponent(fieldvalue)
      }
      return fieldvalue
    },
    query_issystem () {
      return this.$route.query.issystem
    },
    query_viewid () {
      let viewid = this.$route.query.viewid
      return viewid ? viewid * 1 : ''
    },
    viewHideList () {
      return this.viewTabs.filter(item => item.ishide)
    },
    viewShowList () {
      return this.viewTabs.filter(item => !item.ishide)
    },

    selectedTxt () {
      return this.$t('message["1470"]').split('|')
    }
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        const { type: newType } = val.query
        const { type: oldType } = oldVal.query
        newType !== oldType && this.SET_TABLE_SORT({ tableSort: {}, sorter: {} })
      },
      // 深度观察监听
      deep: true
    },
    type (val) {
      this.getViewTabs()
    },
    from (val) {
      this.getViewTabs()
    }
  },
  async created () {
    this.getViewTabs()

    // 获取查询字段
    this.getSearchConfig()
    this.searchConfig && (this.searchConfig.value = this.fieldvalue)

    eventBus.$on('showFilterConfig', this.openFilterConfig)
    eventBus.$on('showFilter', this.openFilter)
  },
  methods: {
    ...mapActions('inquery/listData', ['fetchSearchConfig', 'setSearchConfig', 'setSearchConfig', 'getView']),
    ...mapActions('inquery/filterData', ['setFilterResult', 'setFilterStr']),

    ...mapMutations('inquery/listData', ['SET_TABLE_SORT']),
    async getViewTabs () {
      await this.getView({
        scope: this.from,
        type: this._type
      })
      let defaultItem = this.viewTabs.find(item => item.isdefault === 1)
      this.viewid = this.query_viewid || (defaultItem && defaultItem.id)
      let currSystemItem = this.viewTabs.find(item => item.id === this.viewid) || {}
      this.issystem = this.query_issystem || currSystemItem.issystem
      // 如果从详情返回列表，不重置路由
      if (!this.query.page) {
        this.setViewEvent(false)
      } else {
        // 从详情返回列表，禁止路由跳转
        this.setViewEvent(true)
      }
      if (this.viewid) {
        this.setTabStyle()
      }
    },
    async getSearchConfig () {
      let params = {
        scope: this.from,
        type: this._type
      }
      const chain = await this.fetchSearchConfig()
      chain
        .params({ ...params })
        .fetch()
    },

    handleChangeSearchConfig (val) {
      if (this.searchConfig) {
        this.searchConfig.key = val
      }

      for (let item of this.searchConfig.options) {
        if (item.fieldkey === this.searchConfig.key) {
          this.searchConfig.placeholder = `${this.$t('message["751"]')} ${item.fieldname}`
        }
      }
      this.setSearchConfig(this.searchConfig)
    },
    handleInput () {
      this.setSearchConfig(this.searchConfig)
    },

    onSearch () {
      let query = {
        type: this.type,
        from: this.from,
        fieldkey: this.searchConfig.key,
        fieldvalue: encodeURIComponent(this.searchConfig.value)
      }
      if (this.viewid) {
        query.viewid = this.viewid
        query.issystem = this.issystem
      }
      this.$router.push({
        name: 'InqueryList',
        query
      })
      this.SET_TABLE_SORT({ tableSort: {}, sorter: {} })
    },
    onReset () {
      this.clearSearchConfig()

      let query = {
        type: this.type,
        from: this.from
      }
      if (this.viewid) {
        query.viewid = this.viewid
        query.issystem = this.issystem
      }
      this.$router.push({
        name: 'InqueryList',
        query
      })
    },
    clearSearchConfig () {
      if (this.searchConfig && this.searchConfig.options) {
        this.searchConfig.value = ''
        this.searchConfig.key = this.searchConfig.options[0] && this.searchConfig.options[0].fieldkey
        this.searchConfig.placeholder = this.searchConfig.options[0] ? `${this.$t('message["754"]')}${this.searchConfig.options[0].fieldname}` : this.$t('message["754"]')
      }
    },

    openFilter () {
      this.showFilterModal = true
      this.clearSearchConfig()
    },
    openExport () {
      this.showExportConfigModal = true
    },
    openFilterConfig () {
      this.showFilterConfigModal = true
    },
    clearFilter () {
      this.$refs.filterModal && this.$refs.filterModal.handleClear()
    },
    handleTabs (key) {
      this.viewid = key
      let currSystemItem = this.viewTabs.find(item => item.id === this.viewid) || {}
      this.issystem = currSystemItem.issystem
      this.delayViewEvent()
    },
    delayViewEvent () {
      this.$throttle(this.setViewEvent(), 1000)
    },

    setViewEvent (noJumping) {
      let issystemItem = this.viewTabs.find(item => item.issystem)
      if (this.viewid) {
        if (issystemItem && issystemItem.id === this.viewid) {
          this.showFilterIcon = true
        } else {
          this.showFilterIcon = false
        }
        this.setFilterStr('')
        this.setFilterResult({})
      } else {
        this.showFilterIcon = true
      }

      let query = {
        type: this.type,
        from: this.from
      }
      if (this.viewid) {
        query.viewid = this.viewid
        query.issystem = this.issystem
        query._t = new Date().getTime()
      }
      // 如果 noJumping=true，禁止跳转
      if (!noJumping) {
        this.$router.push({
          name: 'InqueryList',
          query
        })
      }
    },
    setTabStyle () {
      let $copyTab = this.$refs.copyTab
      let $children = $copyTab && $copyTab.children
      let total = 0
      if (!$children || !$children.length) return
      for (let i = 0; i < $children.length; i++) {
        const $ele = $children[i]
        total += $ele.clientWidth
        if (total > 930) {
          this.$set(this.viewTabs[i], 'ishide', true)
        }
      }
    },
    handleClickViewHideMenu (item) {
      this.viewid = item.id
      let currSystemItem = this.viewTabs.find(item => item.id === this.viewid) || {}
      this.issystem = currSystemItem.issystem
      this.delayViewEvent()
    }
  }
}
</script>

<style lang="scss" scoped>
.inquiry-list {
  width: 1040px;
  overflow: auto;
}
.title {
  margin: 16px 0;
}
.filter-num {
  float: left;
  min-width: 255px;
  height: 32px;
  line-height: 32px;
  margin-right: 16px;
  padding: 0 12px;
  text-align: center;
  white-space: nowrap;
  background-color: #e8f4ff;
  border: solid 1px #4ca0f2;
  border-radius: 2px;
  .clear-filter-btn {
    margin-left: 12px;
    font-style: normal;
    cursor: pointer;
    color: #5077aa;
  }
}
.setting-bar {
  .left {
    .ant-input {
      width: 240px;
      margin-right: 16px;
      line-height: 32px;
    }
  }
  .search-form ::v-deep {
    .ant-input-group {
      width: auto;
      margin-right: 16px;
    }
    .ant-select {
      width: 132px;
    }
    .ant-input {
      width: 240px;
    }
    .ant-btn {
      margin-right: 16px;
    }

    .ant-select-arrow {
      margin-top: -8px;
    }
  }
  .right {
    position: relative;

    > span {
      margin-left: 20px;
      cursor: pointer;
    }
    .ant-btn {
      vertical-align: middle;
      &:last-child {
        margin-right: 0;
      }
    }
    .iconfont {
      margin-right: 4px;
      color: #d6d6d6;
      &.fs-blue {
        color: #5077aa;
      }
    }
    .filter-icon.fs-blue {
      .iconfont {
        color: #5077aa;
      }
    }
  }
}
.copy-tab {
  position: absolute;
  left: 9999px;
  width: 99999999999px;
  li {
    padding-right: 24px;
    font-size: 18px;
  }
}
.tab-wrap {
  margin: 8px 0;
  border-top: solid 1px #ebebee;
  .ant-dropdown-link {
    margin-right: 20px;
    padding: 16px 0;
    .iconfont {
      position: relative;
      top: -2px;
      color: #ccc;
      &.fs-blue {
        color: #5077aa;
      }
    }
  }
}
.ant-tabs::v-deep {
  width: 930px;
  .ant-tabs-bar {
    border-bottom: 0;
  }
  .ant-tabs-nav .ant-tabs-tab {
    padding: 12px 0;
    margin-right: 24px;
    font-size: 18px;
  }
  .ant-tabs-tab-arrow-show {
    display: none;
  }
  .ant-tabs-nav-container {
    padding: 0;
  }
}
</style>
